// router.tsx
import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "./protected-route";

const LoginPage = lazy(() => import("../pages/login.page"));
const SignUpPage = lazy(() => import("../pages/sign-up.page"));
const HomePage = lazy(() => import("../pages/home.page"));
const OrdersPage = lazy(() => import("../pages/orders.page"));
const OrderFormPage = lazy(() => import("../pages/order-form.page"));
const CampaignPage = lazy(() => import("../pages/campaign.page"));
const CampaignEditPage = lazy(() => import("../pages/campaign-edit.page"));
const SellersPage = lazy(() => import("../pages/sellers.page"));
const ChangePasswordPage = lazy(() => import("../pages/change-password.page"));

export const router = createBrowserRouter([
  {
    path: "/sign-in",
    element: <LoginPage />,
  },
  {
    path: "/sign-up",
    element: <SignUpPage />,
  },
  {
    path: "/change-password",
    element: <ChangePasswordPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/orders", element: <OrdersPage /> },
      { path: "/orders/new", element: <OrderFormPage /> },
      { path: "/orders/:id/edit", element: <OrderFormPage /> },
      { path: "/campaign", element: <CampaignPage /> },
      { path: "/campaign/edit", element: <CampaignEditPage /> },
      { path: "/sellers", element: <SellersPage /> },
    ],
  },
]);
